import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DocPopupComponent } from '../components/popups/popup.component';
import { DocPopup } from '../models/dialog.models';

@Injectable({ providedIn: 'root' })
export class PopupService {

    constructor(
        private dialog: MatDialog
    ) { }

    openDialog(data: DocPopup) {
        return this.dialog.open(DocPopupComponent, {
            data: data,
            height: '300px',
            width: '450px',
        })

    }

}